import type { BlogPost } from '../types'

export const PIEC_BLEDOW_PRZY_ZBIERANIU_OFERT_FOTOWOLTAICZNYCH: BlogPost = {
  slug: '5-bledow-przy-zbieraniu-ofert-fotowoltaicznych',
  lang: 'pl',
  topicId: '5-bledow-oferty-pv',
  title: '5 błędów przy ofertach fotowoltaicznych',
  metaDescription:
    'Zbierasz oferty na instalację fotowoltaiczną? Poznaj 5 najczęstszych błędów - od numeru ' +
    'telefonu po pomijanie dopłat z programu Mój Prąd.',
  keywords: [
    'błędy przy ofertach fotowoltaicznych',
    'jak porównać oferty fotowoltaiczne',
    'na co uważać przy ofercie na fotowoltaikę',
    'Mój Prąd dofinansowanie fotowoltaika',
    'wybór instalatora fotowoltaiki',
  ],
  publishedAt: '2026-07-12',
  excerpt:
    'Kto zbiera oferty na instalację fotowoltaiczną, popełnia zwykle jeden z tych samych pięciu ' +
    'błędów - od zbyt wczesnego podania numeru telefonu po pominięcie dopłaty z programu Mój Prąd ' +
    'przy liczeniu opłacalności. Oto jak ich uniknąć.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Instalacja fotowoltaiczna to wydatek rzędu kilkudziesięciu tysięcy złotych - a mimo to ' +
        'wiele osób akceptuje pierwszą ofertę, jaką dostaną, albo podejmuje decyzję pod presją ' +
        'telefonu od przedstawiciela handlowego. Poniżej pięć błędów, które najczęściej kosztują ' +
        'realne pieniądze - i jak ich uniknąć.',
    },
    {
      type: 'heading',
      text: '1. Zaakceptowanie pierwszej oferty bez porównania',
    },
    {
      type: 'paragraph',
      text:
        'Ceny za instalację o tej samej mocy potrafią się między firmami różnić nawet o kilkadziesiąt ' +
        'procent - przy tych samych komponentach. Kto zapyta tylko jedną firmę, nie ma punktu ' +
        'odniesienia i nie wie, czy usłyszana cena jest rynkowa, czy zawyżona. Zebranie co najmniej ' +
        'trzech porównywalnych ofert, zanim cokolwiek się podpisze, to najprostszy sposób na ' +
        'realną oszczędność.',
    },
    {
      type: 'heading',
      text: '2. Podanie numeru telefonu i e-maila zbyt wcześnie',
    },
    {
      type: 'paragraph',
      text:
        'Na wielu portalach porównawczych numer telefonu i adres e-mail trzeba podać już przy ' +
        'składaniu zapytania - zanim jakakolwiek firma w ogóle przedstawi ofertę. Efektem bywa fala ' +
        'telefonów od kilku firm jednocześnie, zanim zdąży się porównać choćby dwie oferty w ' +
        'spokoju. Lepiej wybierać rozwiązania, w których dane kontaktowe trafiają do konkretnej ' +
        'firmy dopiero po jej samodzielnym wyborze - nie wcześniej.',
    },
    {
      type: 'heading',
      text: '3. Patrzenie tylko na cenę końcową',
    },
    {
      type: 'paragraph',
      text:
        'Dwie oferty na "10 kWp" nie muszą oznaczać tego samego produktu. Warto sprawdzić rozbicie ' +
        'kosztów: jakie konkretnie moduły i jaki falownik są wyceniane, jaki zakres prac obejmuje ' +
        'oferta (montaż, okablowanie, zgłoszenie do operatora sieci), oraz jaka gwarancja dotyczy ' +
        'samego montażu, a nie tylko sprzętu. Niższa cena przy tańszych komponentach i krótszej ' +
        'gwarancji na robociznę nie zawsze jest tańsza w dłuższej perspektywie.',
    },
    {
      type: 'heading',
      text: '4. Pominięcie dopłat przy liczeniu opłacalności',
    },
    {
      type: 'paragraph',
      text:
        'Program Mój Prąd oraz ulga termomodernizacyjna mogą realnie obniżyć koszt inwestycji, ale ' +
        'warunki i wysokość dofinansowania zmieniają się z naboru na nabór - dlatego warto sprawdzić ' +
        'aktualne zasady bezpośrednio na stronie programu, zanim porówna się "opłacalność" kilku ' +
        'ofert. Część instalatorów wlicza dopłatę do wyceny z góry, inni nie - łatwo więc porównać ' +
        'niewspółmierne kwoty, jeśli nie zapyta się wprost, czy podana cena jest przed czy po ' +
        'dofinansowaniu.',
    },
    {
      type: 'heading',
      text: '5. Brak sprawdzenia opinii i zakresu gwarancji',
    },
    {
      type: 'paragraph',
      text:
        'Cena i specyfikacja to nie wszystko - warto sprawdzić opinie z wcześniejszych realizacji, w ' +
        'miarę możliwości od klientów w podobnym regionie, oraz dopytać, co dokładnie obejmuje ' +
        'gwarancja na montaż (nie mylić z gwarancją producenta modułów czy falownika) i jak wygląda ' +
        'obsługa w razie usterki po instalacji.',
    },
    {
      type: 'heading',
      text: 'Jak to wygląda w praktyce w Roofora',
    },
    {
      type: 'list',
      items: [
        'Jedno anonimowe zapytanie trafia jednocześnie do wielu firm rzemieślniczych w Twoim regionie',
        'Numer telefonu i e-mail podajesz dopiero, gdy sam wybierzesz konkretną firmę - nie wcześniej',
        'Oferty widzisz posortowane według ceny, w spokoju i bez presji czasu',
        'Firmy mogą poprawiać swoją ofertę w dowolnym momencie, więc porównanie jest zawsze aktualne',
      ],
    },
  ],
  relatedLinks: [
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Znajdź instalatora fotowoltaiki', href: '/znajdz-instalatora-fotowoltaiki' },
    { label: 'Ile kosztuje instalacja fotowoltaiczna?', href: '/koszt-instalacji-fotowoltaicznej' },
  ],
}
